import Colorable from "../../mixins/Colorable";

export default {

    mixins: [Colorable],

    props: {
        text: {
            type: [String, Number],
            default: null
        },

        // Whether to center the content
        center: {
            type: Boolean,
            default: false
        },

        help: {
            type: String,
            default: null
        }
    }

}